import { Placement, ProductType, UUID } from '@hc-frontend/core-types';
import { z } from 'zod';

export const BlockDto = z.object({
  name: z.string(),
  position: z.string(),
  size: z.string(),
  max_cpc: z.string(),
  ctr: z.string(),
  expected_revenue: z.string(),
  layout: z.literal('vertical'),
});

export const AdDto = z.object({
  ad_id: z.string(),
  ad_impression_id: z.string(),
  block: z.string(),
  block_position: z.number(),
  brand_name: z.string(),
  click_url: z.string().url(),
  cpc: z.string(),
  deal_type: z.enum(['cpa', 'cpc']),
  display_url: z.string(),
  is_above_fold: z.enum(['true', 'false']),
  metal_level: z.enum(['bronze', 'silver', 'gold', 'platinum']).optional(),
  position_in_block: z.string(),
  position_in_page: z.string(),
  premium: z.string(),
});

export const TrackImpressionRequestDto = z.object({
  blocks: BlockDto.partial().array().default([]),
  ads: AdDto.partial().array().default([]),
  state: z.string(),
  zipcode: z.string(),
  placement: Placement,
  session_id: z.string(),
  ranking_type: z.literal('none'),
  impression_id: z.number(),
  product: ProductType,
  complete_url: z.string().url(),
  domain_short_name: z.string(),
  lead_product: z.string(),
  device: z.enum(['Desktop', 'Mobile', 'Tablet', 'Computer']),
});

export type TrackImpressionRequestDto = z.infer<
  typeof TrackImpressionRequestDto
>;

export const TrackImpressionResponseDto = z.object({
  data: z.object({
    impression_id: UUID,
    message: z.string(),
  }),
  error: z.string().nullable(),
  status: z.number(),
});

export type TrackImpressionResponseDto = z.infer<
  typeof TrackImpressionResponseDto
>;
